export const isBefore18h = () => {
  const now = new Date();
  const timeToShow = now.getHours();
  if (timeToShow || timeToShow === 0) {
    return timeToShow > 9 && timeToShow < 17; // If timeToShow is set, show the modal only between 2am and 6pm
    // return false;
  }
};

export const isAvailableNow = (availability) => {
  if (!availability || availability === "always") return true;
  if (availability === "lunch") return isBefore18h();
  if (availability === "dinner") return !isBefore18h();
  return true;
};
